import React from "react";
import { Box, Typography, Button } from "@mui/material";
import "./templeOfferingsSection.scss";
import ImageViewer from "../../imageviewer/ImageViewer";
import { t } from "i18next";
import { LOCALIZATION } from "../../../utils/localization";
import { KeyboardDoubleArrowRight as KeyboardDoubleArrowRightIcon } from "@mui/icons-material";

interface Props {
  title: string;
  description: string;
  finalPrice: any;
  icon: string;
  type: string;
  buttonText: string;
  templeDetails: any;
  onClick: (type: string) => void;
  currencySymbols: any;
  strikePrice: any;
}

const TempleOfferingsSection: React.FC<Props> = ({
  title,
  description,
  finalPrice,
  strikePrice,
  icon,
  type,
  buttonText,
  templeDetails,
  currencySymbols,
  onClick,
}) => {


  return (
    <>
      <Box className="offeringsSection">
        <Box className="offeringCard">
          <Typography className="title"> {t(title)}</Typography>
          <Typography className="desc">{t(description)}</Typography>

          {strikePrice > 0 && (
            <Typography className="oldPrice">
              {currencySymbols}
              {strikePrice}
            </Typography>
          )}

          <Box className="priceImageRow">
            {
              <Typography className="newPrice">
                {finalPrice > 0 &&  currencySymbols}
                {finalPrice > 0 && finalPrice} <span>{finalPrice > 0 && t(LOCALIZATION.Price_Starts)}</span>
              </Typography>
            }

            <ImageViewer pictureUrl={icon} alt={title} className="pujaLogo" />
          </Box>

          <Button
            className="offeringBtn"
            onClick={() => onClick(type)}
            endIcon={<KeyboardDoubleArrowRightIcon />}
          >
            {t(buttonText)}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default TempleOfferingsSection;
